// src/components/admin/UserRoleBadge.tsx
// ============================================================
// Summit League v2 — User Role Badge
// Color-coded pill for user role (user/moderator/admin)
// ============================================================

import React from 'react';

interface UserRoleBadgeProps {
  role: string;
}

const ROLE_CONFIG: Record<string, { className: string; label: string }> = {
  user:      { className: 'sl-role-badge--user',      label: 'User' },
  moderator: { className: 'sl-role-badge--moderator', label: 'Moderator' },
  admin:     { className: 'sl-role-badge--admin',     label: 'Admin' },
};

export default function UserRoleBadge({ role }: UserRoleBadgeProps) {
  const config = ROLE_CONFIG[role] || { className: '', label: role };

  return (
    <span className={`sl-role-badge ${config.className}`}>
      {config.label}
    </span>
  );
}
